import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DealAnalysisPageComponent } from './component/deal-analysis-page/deal-analysis-page.component';

const routes: Routes = [{ path: '', component: DealAnalysisPageComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DealAnalysisRoutingModule {}
